import { useEffect, useState } from 'react';
import './App.css';
import NavigationBar from './components/navigation/NavigationBar';
import Footer from './components/footer/Footer';
import EmailScreen from './screens/emailScreen/EmailScreen';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import RegistrationScreen from './screens/registrationScreen/RegistrationScreen';
import VerifyCodeScreen from './screens/verifyCodeScreen/VerifyCodeScreen';
import VerificationCompleteScreen from './screens/verificationCompleteScreen/VerificationCompleteScreen';
import PhoneScreen from './screens/phoneScreen/PhoneScreen';
import { loadAudioEyeScript } from './components/navigation/audioeyeScript';

function App() {

  useEffect(()=>{
    loadAudioEyeScript();
  },[]);

  const [communityLogo, setCommunityLogo] = useState<string | null>(null);
  const [communityName, setCommunityName] = useState<string | null>(null);

  return (
    <main id="main">
      <div className="wrapper-body">
        <div className="container-fluid page-content">
          <NavigationBar communityName={communityName} communityLogo={communityLogo} />
          <div className="container page-body-content">
            <BrowserRouter>
              <Routes>
                <Route path="login">
                  <Route index element={<EmailScreen />} />
                  <Route path='phone' element={<PhoneScreen />} />
                  <Route path='verification' element={<VerifyCodeScreen />} />
                  <Route path='verification-complete' element={<VerificationCompleteScreen />} />
                </Route>
                <Route path="signup">
                  <Route index element={<RegistrationScreen communityName={communityName}  setCommunityName={setCommunityName} setCommunityLogo={setCommunityLogo} />} />
                </Route>
              </Routes>
            </BrowserRouter>
          </div>
          <Footer />
        </div>
      </div>
    </main>
  );
}

export default App;
